var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame",
    clipPath: "url(#clip0_56_1378)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.375 1.8335V4.50016H20.625V1.8335H23.375V4.50016H28.875C29.2397 4.50016 29.5894 4.64064 29.8473 4.89069C30.1051 5.14074 30.25 5.47987 30.25 5.8335V27.1668C30.25 27.5205 30.1051 27.8596 29.8473 28.1096C29.5894 28.3597 29.2397 28.5002 28.875 28.5002H4.125C3.76033 28.5002 3.41059 28.3597 3.15273 28.1096C2.89487 27.8596 2.75 27.5205 2.75 27.1668V5.8335C2.75 5.47987 2.89487 5.14074 3.15273 4.89069C3.41059 4.64064 3.76033 4.50016 4.125 4.50016H9.625V1.8335H12.375ZM27.5 13.8335H5.5V25.8335H27.5V13.8335ZM20.6745 15.3482L22.6188 17.2335L15.8125 23.8335L10.9505 19.1188L12.8975 17.2335L15.8139 20.0628L20.6745 15.3482ZM9.625 7.16683H5.5V11.1668H27.5V7.16683H23.375V8.50016H20.625V7.16683H12.375V8.50016H9.625V7.16683Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_56_1378"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33,
    height: 32,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/Calendar.681d736b385ac174809864622a4d72bb.svg";
export { ForwardRef as ReactComponent };